const HOURS_PER_BLOCK = 0.5;

export const blocksToHours = (blocks: number): number => blocks * HOURS_PER_BLOCK;

export const blocksToHoursLabel = (blocks: number): string => {
  const hours = blocksToHours(blocks);
  return `${hours} ${hours === 1 ? "hr" : "hrs"}`;
};

export const normalizeHHMM = (t: string | null | undefined): string => {
  if (!t) return "";
  const [h = "0", m = "0"] = t.trim().split(":");
  return `${h.padStart(2, "0")}:${m.padStart(2, "0")}`;
};
